import React, { forwardRef } from 'react';
import { Box } from '@locus-taxy/neo-ui';

const Divider = forwardRef(({ orientation, color }, ref) => {
    const borderColor = color || 'grey.200';
    const borderProps =
        orientation === 'vertical'
            ? {
                  border: 'none',
                  borderLeftWidth: '0.0625rem',
                  borderLeftStyle: 'solid',
                  borderLeftColor: borderColor,
                  width: 'auto',
                  height: 'auto',
                  mx: 2
              }
            : {
                  border: 'none',
                  borderBottomWidth: '0.0625rem',
                  borderBottomStyle: 'solid',
                  borderBottomColor: borderColor,
                  width: 'auto',
                  height: 'auto',
                  my: 2
              };

    return (
        <Box
            ref={ref}
            as="hr"
            aria-orientation={orientation}
            sx={borderProps}
        />
    );
});

export default Divider;
